import { useState } from "react";
import { ChevronDown } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

const FAQS = [
  { q: "Can DecodeKid see or track my child's phone?", a: "No. DecodeKid never connects to any device, app or account. It's a parent-only tool. You type what you've seen or heard, and we help you understand it." },
  { q: "Is my child's information private?", a: "Yes. Every child profile and everything you type is encrypted with a key unique to your account. No staff member or support agent can ever read it." },
  { q: "Is this therapy or medical advice?", a: "No. DecodeKid is a gentle guide for everyday moments. It never diagnoses. If something serious comes up, we show calm safety notices and helplines." },
  { q: "How does the free trial work?", a: "Every verified account gets 3 full days of everything — all tools, up to 5 child profiles — with no credit card. After that you can subscribe to keep going." },
  { q: "How does the AI work?", a: "Your text is sent securely to our AI provider only to create an answer, under an agreement that forbids training on it or human review. We mask phone numbers and emails automatically." },
  { q: "Can I cancel any time?", a: "Yes. Cancel whenever you like and your access continues to the end of the period you've paid for. Payments are final except where your local law says otherwise." },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <div>
      <PublicNav />
      <section className="dk-container py-16 max-w-3xl">
        <span className="badge-soft mb-3">FAQ</span>
        <h1 className="text-[32px] sm:text-[40px] font-semibold mb-8">Questions parents ask</h1>
        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} className="dk-card overflow-hidden" data-testid="faq-item">
              <button className="w-full flex items-center justify-between gap-4 p-5 text-left" onClick={() => setOpen(open === i ? -1 : i)} data-testid="faq-toggle">
                <span className="font-sans font-semibold">{f.q}</span>
                <ChevronDown size={18} className="shrink-0 transition-transform" style={{ transform: open === i ? "rotate(180deg)" : "none" }} />
              </button>
              {open === i && <p className="px-5 pb-5 text-sm anim-in" style={{ color: "var(--text-muted)" }}>{f.a}</p>}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
